<template>
  <div v-if="questionList.length>0">
    <div class="assignment-swiper-wrap">
      <DotLoading v-if="isLoading"/>
      <div v-else class="assignment-swiper">
        <div class="assignment-swiper_content">
          <p class="assignment-title">
            {{ title }}
          </p>
          <p class="assignment-title small">
            {{ ingQuestionIndex + 1 }} / {{ questionList.length }}
          </p>
          <div
            v-if="_chapter"
            class="chapter-text"
          >
            {{ _chapter }}<span
              v-if="_section"
              class="section-text"
            >{{ _section }}</span>
          </div>
          <p class="content-text">
            {{ questionList[ingQuestionIndex].question.title }}
          </p>
          <WsTextButton001
            v-if="_showStandardPopupBtn"
            primary
            no-padding
            leading-icon="icon-light"
            @click="standardPopupOpen()"
          >
            {{ checkBtn }}
          </WsTextButton001>
        </div>
        <div class="assignment-swiper_content">
          <StateInputButton
            v-if="questionList[ingQuestionIndex].question.quesType === 1"
            v-model="questionList[ingQuestionIndex].answer.score"
            :placeholder="$t('請輸入觀測值')"
            type="Number"
          />
          <LlBtnGroups
            v-else
            v-model="questionList[ingQuestionIndex].answer.score"
            normal-size
            @input="$_getBtnScore($event)"
          />
          <div class="assignment-swiper_content-bottom-btn">
            <p
              v-if="_nextBtnDisableActive"
              class="warning-text"
            >
              <i class="icon-warning" /> {{ _getBtnTextLabel }}
            </p>
            <WsButton001
              out-line
              width200
              leading-icon="icon-edit-pencil"
              @click="$_remarkPopupOpen()"
            >
              {{ $t('輸入備註') }}
            </WsButton001>
          </div>
        </div>
        <div class="assignment-swiper_nav-btns">
          <div
            class="btn"
            @click="preQuestionClick()"
          >
            <i class="icon-chevron-back" />
          </div>
          <div
            class="btn"
            :class="{disabled:_nextBtnDisableActive}"
            @click="nextQuestionClick()"
          >
            <i class="icon-chevron-forward" />
          </div>
        </div>
      </div>
      <LlNormalPopup
        :popup-active="standardPopupActive"
        title-icon="icon-light"
        :popup-title="popupTitle"
        :popup-content="questionList[ingQuestionIndex].question.remark ?questionList[ingQuestionIndex].question.remark:$t('無')"
        :images="questionList[ingQuestionIndex].question.images"
        :attaches="questionList[ingQuestionIndex].question.attaches"
        :tempImages="questionList[ingQuestionIndex].question.tempImages"
        :tempAttaches="questionList[ingQuestionIndex].question.tempAttaches"
        @popup-close="standardPopupClose()"
      />
      <LlQuestionRemarkPopup
        :title="$t('輸入備註')"
        :active="remarkPopupActive"
        :images="questionList[ingQuestionIndex].answer.images"
        :remark="questionList[ingQuestionIndex].answer.remark"
        :uploadModule="uploadModule"
        @popup-close="$_remarkPopupClose()"
        @submit="$_remarkPopupSubmit(ingQuestionIndex,$event)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "AssignmentSwiper",
  props: {
    popupTitle: {
      type: String,
      default() {
        return this.$t("查核提示");
      },
    },
    title: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    questionIndex: {
      type: Number,
      default: 0,
    },
    checkBtn: {
      type: String,
      default() {
        return this.$t("查看合規標準");
      },
    },
    btnList: {
      type: Array,
      default() {
        return [];
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    uploadModule: {
      type: String,
    }
  },
  data: () => ({
    ingQuestionIndex: 0,
    questionList: [],
    remarkPopupActive: false,
    standardPopupActive: false,
    remarkcontent: {},
    remarkTextContent: "",
    remarkPreviewImg: false,
    previewFiles: false,
    ingPreviewFile: "",
  }),
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _nextBtnDisableActive() {
      const questionScore =
        this.questionList[this.ingQuestionIndex].answer.score;
      const questionRemark =
        this.questionList[this.ingQuestionIndex].answer.remark;
      const questionRemarkLen = questionRemark
        ? questionRemark.replace(/\s+/g, "").length
        : 0;
      if (questionScore === 25) {
        return false;
      } else if (
        (questionScore === 21 && questionRemarkLen === 0) ||
        (questionScore === 22 && questionRemarkLen === 0) ||
        (questionScore === 23 && questionRemarkLen === 0) ||
        (questionScore === 20 && questionRemarkLen === 0)
      ) {
        return true;
      } else {
        return false;
      }
    },
    _getBtnTextLabel() {
      const btnList = this.btnList;
      const selectedBtnScore =
        this.questionList[this.ingQuestionIndex].answer.score;
      if (!selectedBtnScore) return;
      let selectedBtn = btnList.find((btn) => btn.score === selectedBtnScore);
      return `${this.$t("{item} 必須寫下備註", {
        item: selectedBtn.textLabel,
      })}`;
    },
    _chapter() {
      return this.questionList[this.ingQuestionIndex].question.chapter;
    },
    _section() {
      return ` | ${this.questionList[this.ingQuestionIndex].question.section}`;
    },
    _showStandardPopupBtn() {
      if (
        !this.questionList ||
        !this.questionList[this.ingQuestionIndex] ||
        !this.questionList[this.ingQuestionIndex].question
      ) {
        return false;
      }
      if (!this.questionList[this.ingQuestionIndex].question.remark) {
        return false;
      }
      if (!this.questionList[this.ingQuestionIndex].question.attaches) {
        return false;
      }
      return true;
    },
  },
  watch: {
    value() {
      this.questionList = [...this.value];
    },
    questionIndex() {
      this.ingQuestionIndex = this.questionIndex;
    },
  },
  mounted() {
    this.questionList = [...this.value];
    this.ingQuestionIndex = this.questionIndex;
  },
  methods: {
    $_getBtnScore($event) {
      this.questionList[this.ingQuestionIndex].answer.score = $event;
      if ($event === 20 || $event === 21 || $event === 22 || $event === 23) {
        this.$_remarkPopupOpen();
      }
    },
    $_deleteImageFromRemark(index, imageList) {
      imageList.splice(index, 1);
    },
    $_getRemindTextActive(score) {
      if (score == "0%" || score == "50%") {
        return true;
      } else {
        return false;
      }
    },
    $_remarkPopupOpen() {
      this.remarkPopupActive = true;
    },
    $_remarkPopupClose() {
      this.remarkPopupActive = false;
    },
    $_resetAnswerRemark(index) {
      this.questionList[index].answer.images = [];
      this.questionList[index].answer.remark = "";
    },
    $_remarkPopupSubmit(index, $event) {
      this.$emit('submit', {index, ...$event});
      this.remarkPopupActive = false;
    },
    standardPopupOpen() {
      this.standardPopupActive = true;
    },
    standardPopupClose() {
      this.standardPopupActive = false;
    },
    remarkPreviewImgClose() {
      this.remarkPreviewImg = false;
    },
    remarkPreviewImgOpen() {
      this.remarkPreviewImg = true;
    },
    previewFilesOpen() {
      this.previewFiles = true;
    },
    previewFilesClose() {
      this.previewFiles = false;
    },
    nextQuestionClick() {
      //remark is empty and questionList is 不合規 || 部分合規 => return
      //ingQuestionIndex +1 to next question
      if (this._nextBtnDisableActive === true) return;
      if (this.ingQuestionIndex + 1 === this.questionList.length) {
        this.$emit("input", this.questionList);
        this.$emit("check-end");
        return;
      }
      this.ingQuestionIndex = this.ingQuestionIndex + 1;
      this.$emit("fetch-ques", this.ingQuestionIndex);
    },
    preQuestionClick() {
      //ingQuestionIndex -1 to pre question
      if (this.ingQuestionIndex === 0) {
        this.$emit("return-start");
        return;
      }
      this.ingQuestionIndex = this.ingQuestionIndex - 1;
      this.$emit("fetch-ques", this.ingQuestionIndex);
    },
    convertPercentToText(num) {
      if (num == "100%") {
        return this.$t("合規");
      } else if (num == "50%") {
        return this.$t("部分合規");
      } else {
        return this.$t("不合規");
      }
    },
    activingValue(score, value) {
      if (score == value) {
        return true;
      } else {
        return false;
      }
    },
    $_getRemarkByData(data, $event) {
      data = $event;
    },
    $_getImagesByData(data, $event) {
      data = $event;
    },
    $_onInput($event, ingQuestionIndex) {
      this.$emit('input', {...$event, index: ingQuestionIndex});
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/assignment-swiper";
</style>